import { useModal } from '@/common/components/modal-provider/hooks/useModal';
import { InviteMemberDialogContent } from './InviteMemberDialog';

export function useInviteMemberDialog() {
  const showModal = useModal();
  return (orgId: number) =>
    showModal<void>({
      content: ({ resolve }) => <InviteMemberDialogContent orgId={orgId} resolve={resolve} />,
    });
}
